import React, {Component} from 'react'
import { Hook, Console, Decode } from 'console-feed'

export default class VConsole extends Component {
  state = {
    show: false,
    logs: []
  };
  componentDidMount() {
    Hook(window.console, log => {
      this.setState(({ logs }) => ({ logs: [...logs, Decode(log)] }))
    });
  }
  toggleShow = () => {
    this.setState({show: !this.state.show});
  };
  render() {
    return (
      <div style={{ backgroundColor: '#242424' }}>
        <button onClick={this.toggleShow}>vConsole</button> {this.state.show}
        <Console logs={this.state.logs} variant="dark" />
      </div>
    )
  }
}
